exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-outer-pg{\n    margin: -40px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/user-bookmarks/user-bookmarks.component.css
// module id = ../../../../../src/app/home/user-bookmarks/user-bookmarks.component.css
// module chunks = common